import { i18n } from './AdvancedSearch-i18n.ts';
import type { FilterStateType } from './AdvancedSearch-types.ts';

export const defaultOptionValue = 'default';
export const CROSSPRODUCT_SEARCH_API = 'crossProductSearch';
export const CONFLUENCE_SEARCH_API = 'confluenceSearch';

export enum FilterIds {
	SPACES = 'spaces',
	CONTRIBUTORS = 'contributors',
	TYPE = 'type',
	LABELS = 'labels',
	VERIFIED = 'verified',
	ANCESTOR = 'ancestor',
	DATE = 'date',
	MORE = 'moreFilters',
	CONTENT_UNDER = 'contentUnder',
	ARCHIVED_CONTENT = 'archivedContent',
	SEARCH_TITLE_ONLY = 'searchTitleOnly',
}

export enum OptionIds {
	TITLE = 'title',
	ARCHIVED = 'archived',
	ANCESTOR = 'ancestor',
	TO = 'to',
	FROM = 'from',
	LAST_MODIFIED = 'lastModified',
	VERIFIED = 'verified',
}

export enum InputVariants {
	SELECTOR_WITH_AVATAR = 'selectorWithAvatar',
	SELECT = 'select',
	CHECKBOX = 'checkbox',
	USER_PICKER = 'userPicker',
	BUTTON = 'pillButton',
	SEARCH_BUTTON = 'searchButton',
	DATE_PICKER = 'datePicker',
	MORE = 'more',
	TAG = 'tag',
}

export const PAGE_SIZE = 25;
export const QUERY_PARAM_ARRAY_SEPARATOR = ',';
export const DEFAULT_ENTITIES = [
	'ati:cloud:confluence:page',
	'ati:cloud:confluence:attachment',
	'ati:cloud:confluence:blogpost',
	'ati:cloud:confluence:space',
	'ati:cloud:confluence:embed',
	'ati:cloud:confluence:folder',
];
export const CONFLUENCE_AS_EXPERIENCE = 'confluence.advancedSearch';
export const CONFLUENCE_ARI = 'ari:cloud:confluence::site/';
export const CONTEXT_PATH = '/wiki';
export const CURRENT = 'CURRENT';
export const ARCHIVED = 'ARCHIVED';
export const INCLUDEARCHIVEDSTATUS = ['CURRENT', 'ARCHIVED'];

export enum LastModifiedValues {
	ANY_TIME = '',
	TODAY = 'today',
	YESTERDAY = 'yesterday',
	PAST_SEVEN_DAYS = 'past7Days',
	PAST_THIRTY_DAYS = 'past30Days',
	PAST_YEAR = 'pastYear',
	CUSTOM = 'custom',
	LAST_DAY = 'lastDay',
	LAST_WEEK = 'lastWeek',
	LAST_MONTH = 'lastMonth',
	LAST_YEAR = 'lastYear',
}

export const isoPattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}/;

export enum ConfluenceATIs {
	PAGE = 'ati:cloud:confluence:page',
	ATTACHMENT = 'ati:cloud:confluence:attachment',
	BLOG = 'ati:cloud:confluence:blogpost',
	SPACE = 'ati:cloud:confluence:space',
	COMMENT = 'ati:cloud:confluence:comment',
	WHITEBOARD = 'ati:cloud:confluence:whiteboard',
	DATABASE = 'ati:cloud:confluence:database',
	EMBED = 'ati:cloud:confluence:embed',
	FOLDER = 'ati:cloud:confluence:folder',
}

export const lastModifiedFilterOptions = [
	{
		value: defaultOptionValue,
		label: { ...i18n.dateFilterAnyTime },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.TODAY,
		label: { ...i18n.dateFilterToday },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.YESTERDAY,
		label: { ...i18n.dateFilterYesterday },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.PAST_SEVEN_DAYS,
		label: { ...i18n.dateFilterLastWeek },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.PAST_THIRTY_DAYS,
		label: { ...i18n.dateFilterLastMonth },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.PAST_YEAR,
		label: { ...i18n.dateFilterLastYear },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
	{
		value: LastModifiedValues.CUSTOM,
		label: { ...i18n.dateFilterCustom },
		isSelected: false,
		optionId: OptionIds.LAST_MODIFIED,
	},
];

export const titleFilterOption = {
	label: { ...i18n.searchFilterTitle },
	value: 'title',
	isSelected: false,
};

export const archivedFilterOption = {
	label: { ...i18n.searchFilterArchived },
	value: 'archived',
	isSelected: false,
};

export const toFilterOption = {
	value: '',
	label: '',
	isSelected: false,
	optionId: OptionIds.TO,
};

export const fromFilterOption = {
	value: '',
	label: '',
	isSelected: false,
	optionId: OptionIds.FROM,
};

export const verifiedOption = {
	value: 'verified',
	label: { ...i18n.searchFilterVerified },
	isSelected: false,
};

export const defaultFilterState: FilterStateType = {
	[FilterIds.SPACES]: [],
	[FilterIds.CONTRIBUTORS]: [],
	[FilterIds.TYPE]: [],
	[FilterIds.DATE]: {
		[OptionIds.LAST_MODIFIED]: [...lastModifiedFilterOptions],
		[OptionIds.TO]: toFilterOption,
		[OptionIds.FROM]: fromFilterOption,
	},
	[FilterIds.LABELS]: [],
	[FilterIds.VERIFIED]: [verifiedOption],
	[FilterIds.ANCESTOR]: [],
	[FilterIds.MORE]: [titleFilterOption, archivedFilterOption],
};
